import styled from "@emotion/styled"
import HeroCaseItemText from "components/HeroCase/HeroCaseItemText"

const HeroScrollItemText = styled(HeroCaseItemText)`
  font-weight: 500;
`

export default HeroScrollItemText
